export default __webpack_public_path__ + "static/media/impale.b53d7b3d.png";